"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONT_VERTICAL_CENTER_OFFSET_RATIO = exports.DEFAULT_CHART_TOP_PADDING = exports.DEFAULT_THROTTLING_INTERVAL = exports.AXIS_TYPES = exports.LINE_CHART_PADDING = exports.MAX_HOVER_DISTANCE = exports.DEFAULT_FONT_SIZE = exports.DEFAULT_LINE_WEIGHT = exports.AXIS_TEXT_COLOR = exports.AXIS_LINE_COLOR = exports.FONT_FAMILY = void 0;
const lodash_1 = __importDefault(require("lodash"));
const format_1 = require("./format");
exports.FONT_FAMILY = 'source sans pro,system-ui,blinkmacsystemfont,-apple-system,roboto,oxygen,ubuntu,cantarell,fira sans,droid sans,helvetica neue,"sans-serif"';
exports.AXIS_LINE_COLOR = '#E6E6E6';
exports.AXIS_TEXT_COLOR = '#4D4D4D';
exports.DEFAULT_LINE_WEIGHT = 5;
exports.DEFAULT_FONT_SIZE = 13;
exports.MAX_HOVER_DISTANCE = 200;
/** Fix These */
exports.LINE_CHART_PADDING = 10;
exports.AXIS_TYPES = (0, lodash_1.default)(format_1.VALUE_FORMATS).omit(['default']).keys().value();
exports.DEFAULT_THROTTLING_INTERVAL = 17;
exports.DEFAULT_CHART_TOP_PADDING = 20;
exports.FONT_VERTICAL_CENTER_OFFSET_RATIO = 0.35;